var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputerSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dad7e5;}.cls-2{fill:#edebf2;}.cls-3{fill:#8bd1ea;}.cls-4{fill:#9fdbf3;}.cls-5{fill:#b2e5fb;}.cls-6{fill:#c6c3d8;}.cls-7{fill:#374f68;}.cls-8{fill:#425b72;}.cls-9{fill:#db5669;}.cls-10{fill:#6fabe6;}.cls-11{fill:#9dcc6b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Computer Web Coding ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Computer_Web_Coding",
    "data-name": "Computer Web Coding"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45,9V33H3V9A2,2,0,0,1,5,7H43A2,2,0,0,1,45,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45,9V31H30A24,24,0,0,1,6,7H43A2,2,0,0,1,45,9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5,
    y: 9,
    width: 38,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45,33v4a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2V33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45,33v4H10a4,4,0,0,1-4-4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 9,
    y: 7,
    width: 30,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M39,7V31H36A24,24,0,0,1,12,7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 19,
    y: 39,
    width: 10,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,47H19V41h2A6,6,0,0,1,27,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,47H15a1,1,0,0,1,0-2H33A1,1,0,0,1,33,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39,3V7H9V3a2,2,0,0,1,2-2H37A2,2,0,0,1,39,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39,3V7H12V3a2,2,0,0,1,2-2H37A2,2,0,0,1,39,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M25,36a1,1,0,0,0-2,0A1,1,0,0,0,25,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M14,4a1,1,0,0,0-2,0A1,1,0,0,0,14,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M18,4a1,1,0,0,0-2,0A1,1,0,0,0,18,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M22,4a1,1,0,0,0-2,0A1,1,0,0,0,22,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M20,24c-.56,0-.3.12-4.71-4.29a1,1,0,0,1,0-1.42l4-4a1,1,0,0,1,1.42,1.42L17.41,19l3.3,3.29A1,1,0,0,1,20,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M28,24a1,1,0,0,1-.71-1.71L30.59,19l-3.3-3.29a1,1,0,0,1,1.42-1.42l4,4a1,1,0,0,1,0,1.42C28.34,24.08,28.56,24,28,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M22,23.8l2-10a1,1,0,0,1,2,.4l-2,10A1,1,0,0,1,22,23.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerSvg);
export default __webpack_public_path__ + "static/media/computer-svg.d3cb6952daead4d8f1c0f29c7781d4a4.svg";
export { ForwardRef as ReactComponent };